import React from 'react';
import { Chip, Box } from '@material-ui/core';
import { amber, lightBlue, green, red } from '@material-ui/core/colors';
import { stateMap } from 'config';

function StatusChip({ status }) {
  let coloredChip;
  switch (status) {
    case 1:
      coloredChip = (
        <Chip
          size="small"
          label={stateMap[status]}
          color={'primary'}
          style={{ backgroundColor: lightBlue[500] }}
        />
      );
      break;
    case 2:
      coloredChip = (
        <Chip
          size="small"
          label={stateMap[status]}
          color={'primary'}
          style={{ backgroundColor: amber[500] }}
        />
      );
      break;
    case 3:
      coloredChip = (
        <Chip
          size="small"
          label={stateMap[status]}
          color={'primary'}
          style={{ backgroundColor: green[500] }}
        />
      );
      break;
    case 4:
      coloredChip = (
        <Chip
          size="small"
          label={stateMap[status]}
          color={'secondary'}
          style={{ backgroundColor: red['A400'] }}
        />
      );
      break;
    case 5:
      coloredChip = (
        <Chip
          size="small"
          label={stateMap[status]}
          color={'secondary'}
          style={{ backgroundColor: '#30475E' }}
        />
      );
      break;
    case 6:
      coloredChip = (
        <Chip
          size="small"
          label={stateMap[status]}
          color={'secondary'}
          style={{ backgroundColor: '#3E8E7E' }}
        />
      );
      break;
    default:
      coloredChip = (
        <Chip
          size="small"
          label={stateMap[status]}
          color={'primary'}

        />
      );
      break;
  }

  return <Box>{coloredChip}</Box>;
}

export default StatusChip;
